
export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const GET_PRODUCTS_REQUEST_SEARCHBAR = "GET_PRODUCTS_REQUEST_SEARCHBAR";
export const GET_PRODUCTS_SUCCESS_SEARCHBAR = "GET_PRODUCTS_SUCCESS_SEARCHBAR";
export const GET_PRODUCTS_FAILURE_SEARCHBAR = "GET_PRODUCTS_FAILURE_SEARCHBAR";

export const ADD_PRODUCT_REQUEST = "ADD_PRODUCT_REQUEST";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

export const EDIT_PRODUCT_REQUEST = "EDIT_PRODUCT_REQUEST";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILURE = "EDIT_PRODUCT_FAILURE";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const PATCH_BOOK_LOADING ="PATCH_BOOK_LOADING"
export const PATCH_BOOK_SUCESS ="PATCH_BOOK_SUCESS"
export const PATCH_BOOK_FAILURE ="PATCH_BOOK_FAILURE"

export const ADD_PRODUCT_REQUEST_AGAIN = "ADD_PRODUCT_REQUEST_AGAIN";
export const ADD_PRODUCT_SUCCESS_AGAIN = "ADD_PRODUCT_SUCCESS_AGAIN";
export const ADD_PRODUCT_FAILURE_AGAIN = "ADD_PRODUCT_FAILURE_AGAIN";

export const DELETE_PRODUCT_REQUEST_AGAIN = "DELETE_PRODUCT_REQUEST_AGAIN";
export const DELETE_PRODUCT_SUCCESS_AGAIN = "DELETE_PRODUCT_SUCCESS_AGAIN";
export const DELETE_PRODUCT_FAILURE_AGAIN = "DELETE_PRODUCT_FAILURE_AGAIN";